import { Timestamp } from "rxjs";

/** True for invalid dates or calendar placeholders (e.g. .NET DateTime default 0001-01-01 → UI was "01/01/1"). */
export function isSentinelCalendarDate(date: Date): boolean {
    if (!date || isNaN(date.getTime())) return true;
    return date.getFullYear() < 100;
}

export function getDate(date: Date) {
    var _date = new Date(date);
    if (isSentinelCalendarDate(_date)) return "";

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()}`;
}



export function getDateFromString(date: string) {
    var _date = new Date(date);
    if (isSentinelCalendarDate(_date)) return "";

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()}`;
}

export function getDateTime(date: Date) {
    var _date = new Date(date);
    if (isSentinelCalendarDate(_date)) return "";

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()} ${h}:${mi}`;
}

export function getToday() {
    let newDate = new Date();
    return new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
}

export const getTodayDateString = () => {
    let d = new Date();
    d.setDate(d.getDate());
    return getDateString(d);
}

export const getTwoWeeksAheadDateString = () => {
    let d = new Date();
    d.setDate(d.getDate() + 14);
    return getDateString(d);
}

export const getDateString = (date: Date) => {
    date = new Date(date);
    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return `${yy}-${mm}-${dd}`;
}

export const getTimeFromDateTimeString = (dateTimeString: string) => {

    const [day, month, yearTime] = dateTimeString.split('/');
    const [year, time] = yearTime.split(' ');
    const [hours, minutes] = time.split(':');

    const dateObject = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hours, 10), parseInt(minutes, 10));

    const extractedTime = dateObject.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    return extractedTime;

};

export const removeSecondsFromTime = (time: any) => {
    let formattedTime = time.substr(0, 5);
    return formattedTime;
}

export const getFormatedDate = (dateStr: string) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isSentinelCalendarDate(d)) return '';
    return dateStr.split('T')[0]; // Extracts '2025-06-06'
};

export const getDateStringNormalized = (date: Date, withTime?: boolean) => {
    if (!date) return;

    if (date instanceof Date !== true) {
        date = new Date(date);
    }

    if (isSentinelCalendarDate(date)) return '';

    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    var _return = `${dd}/${mm}/${yy}`;

    if (withTime) {
        let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let MM = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        return `${_return} ${hh}:${MM}`;
    }
    return _return;
}

export const getStringDateNormalized = (dateString?: string, withTime?: boolean) => {
    if (!dateString) return "";
    let date = new Date(dateString);
    if (isSentinelCalendarDate(date)) return "";
    return getDateStringNormalized(date, withTime);
}

export function formatTime(date: string | number | Date): string {
    if (!date) return '';

    const d = new Date(date);

    if (isNaN(d.getTime())) return '';

    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}